import React, { useMemo } from 'react'
import { Redirect } from 'react-router-dom'
import { AbilityContext } from '@app/context/ability-context'
import { defineStudentAbilities, authorize } from '@app/ability'
import { statePath } from '@app/helpers/studentsHelper'
import WarmUpBanner from "@app/components/shared/WarmUpBanner";
import Headbar from '@app/components/shared/Headbar'

const headerRestrictedPages = ['Solution', 'InappropriateGrade']
const bannerRestrictedPages = ['Solution']

const StudentLayout = ({ component: Component, student, route, global, landscape }) => {
  const ability = useMemo(() => defineStudentAbilities(student, global), [student, global]);

  const shouldRenderHeader = useMemo(() => {
    const name = Component.displayName || Component.name;
    return !headerRestrictedPages.includes(name);
  }, [Component]);

  const shouldRenderBanner = useMemo(() => {
    const name = Component.displayName || Component.name;
    return !bannerRestrictedPages.includes(name);
  }, [Component]);

  if (!authorize(ability, Component)) {
    return <Redirect to={statePath(ability)} />;
  }

  return (
    <AbilityContext.Provider value={ability}>
      <div className={`w-flex-layout layout layout--public ${landscape ? 'layout--force-landscape' : ''}`}
           style={{ marginTop: shouldRenderHeader ? '45px' : '0px' }}>
        <div className="w-flex-layout__top header-section__top">
          {shouldRenderHeader && (
            <Headbar global={global} user={student} route={route} />
          )}
        </div>
        {shouldRenderBanner && <WarmUpBanner event={global.event} />}
        <div className="w-flex-layout__center">
          <Component student={student} route={route} global={global} />
        </div>
        <div className="w-flex-layout__bottom" />
      </div>
    </AbilityContext.Provider>
  );
};

export default StudentLayout;
